import { useEffect, useState } from "react";

import { contactDirectoryDataDate } from "../contacts/contactDirectory.js";
import { useI18n } from "../i18n/I18nProvider.js";
import { getBundleStorageSnapshot } from "../offline/database.js";

interface BundleInfo {
  readonly id: string;
  readonly version: string;
}

export function BuildInformation() {
  const { locale, t } = useI18n();
  const [bundle, setBundle] = useState<BundleInfo>();

  useEffect(() => {
    let active = true;
    const load = () => {
      void getBundleStorageSnapshot(locale).then((snapshot) => {
        if (!active) return;
        const body = snapshot.activeBundle?.bundle.body;
        setBundle(
          body === undefined ? undefined : { id: body.bundleId, version: body.contentVersion },
        );
      });
    };
    load();
    window.addEventListener("safesphere:content-state-changed", load);
    return () => {
      active = false;
      window.removeEventListener("safesphere:content-state-changed", load);
    };
  }, [locale]);

  return (
    <section aria-labelledby="build-information-title" className="settings-card build-information">
      <div>
        <p className="build-information__eyebrow">{t("build.stage")}</p>
        <h2 id="build-information-title">{t("build.title")}</h2>
        <p>{t("build.body")}</p>
      </div>
      <dl>
        <div>
          <dt>{t("build.version")}</dt>
          <dd>{__APP_VERSION__}</dd>
        </div>
        <div>
          <dt>{t("build.date")}</dt>
          <dd>{__BUILD_DATE__.slice(0, 10)}</dd>
        </div>
        <div>
          <dt>{t("build.bundle")}</dt>
          <dd>
            {bundle === undefined ? t("build.bundle_none") : `${bundle.id} · ${bundle.version}`}
          </dd>
        </div>
        <div>
          <dt>{t("build.contacts_date")}</dt>
          <dd>{contactDirectoryDataDate}</dd>
        </div>
      </dl>
    </section>
  );
}
